import { createApp } from 'vue'

import './utils/pageTitle.js'

import App from './App.vue'
// import router from '@/router'
import router from './router/index'

createApp(App).use(router).mount('#app')
